/**
 * Утилиты для валидации ИНН (RU версия)
 * Чистые функции без зависимостей от Vue
 *
 * Примечание: Полная проверка ИНН выполняется на сервере через API,
 * здесь только базовая проверка формата перед отправкой
 */

/**
 * Проверяет формат ИНН (базовая валидация перед отправкой на сервер)
 * @param {String} inn - ИНН для проверки
 * @returns {Object} { isValid: boolean, error: string }
 */
export function validateInnFormat(inn) {
  if (!inn) {
    return {
      isValid: false,
      error: 'business_account_data.input_inn', // Ключ для i18n
    };
  }

  // Удаляем пробелы и лишние символы
  const cleanInn = inn.replace(/\s+/g, '');

  // ИНН должен содержать только цифры
  if (!/^\d+$/.test(cleanInn)) {
    return {
      isValid: false,
      error: 'business_account_data.inn_format_error',
    };
  }

  // ИНН должен быть 10 или 12 цифр
  if (cleanInn.length !== 10 && cleanInn.length !== 12) {
    return {
      isValid: false,
      error: 'business_account_data.inn_length_error',
    };
  }

  return { isValid: true, error: '' };
}
